/**
* @ngdoc service
* @name  sharebase.sbSearchService
* 
* @description 
* A service used to retrieve with ShareBase content search
* documents
**/
export function SearchServiceFactory(
	$http:ng.IHttpService, 
	$q:ng.IQService, 
	settingsService
) {
	const apiUri = settingsService.serverAPIPath + '/search';	

	return {
		/**
		* @ngdoc method
		* @name sbSearchService#getResults
		* @methodOf sharebase.sbSearchService
		* @kind function
		*
		* @description
		* Gets matching results of the search
		* 
		* @param {object} searchPhrase A text phrase to search for
		* @param {object} resultLimit The amount of results to return.  Possible
		* values 0-1000 (default) is 100
		*
		* @returns {Deferred} A promise that will resolve with a list of results
		* 
		*/
		getResults
	};

	function getResults(searchPhrase, resultLimit) {
		let p;
		let results = [];

		if (!searchPhrase || searchPhrase.length === 0) {
			p = $q.resolve(results);
		}
		else {
			let searchPhraseArr = searchPhrase.split(/\s/g);

			//set a default result limit
			resultLimit = (typeof resultLimit === 'number') && resultLimit > 0 ? 
				parseInt(resultLimit.toString()) :
				100 ;
				
			p = $http
				.post<any>(apiUri, searchPhraseArr, { 
					params: { 
						limit: resultLimit 
					} 
				})
				.then(function (response) {
					results = [];
					results = results.concat(response.data.Embedded.Folders.map(function (folder) {
						folder.name = folder.FolderName;
						return folder;
					}));

					results = results.concat(response.data.Embedded.Documents.map(function (doc) {
						doc.name = doc.DocumentName;
						return doc;
					}));

					return { 
						results: results, 
						hasMore: response.data.HasMore 
					};
				});
		}

		return p;
	}
}

SearchServiceFactory.$inject =  [
	'$http', 
	'$q', 
	'settingsService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/searchService.ts